import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useIsPro } from "@/hooks/useIsPro";
import { JUST_UPGRADED_KEY } from "@/hooks/useLencoPayment";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export function WelcomeToProScreen() {
  const { user } = useAuth();
  const isPro = useIsPro();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const flag = window.sessionStorage.getItem(JUST_UPGRADED_KEY);
      if (flag === "1" && user && isPro) setShow(true);
    } catch {
      /* ignore */
    }
  }, [user, isPro]);

  const dismiss = () => {
    try {
      window.sessionStorage.removeItem(JUST_UPGRADED_KEY);
    } catch {
      /* ignore */
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="post-upgrade-screen" className="fixed inset-0 z-[100] flex items-center justify-center bg-background/95 backdrop-blur-md">
      <div className="max-w-md mx-auto text-center p-8 space-y-6">
        <div className="mx-auto w-20 h-20 rounded-full bg-primary/20 flex items-center justify-center">
          <Sparkles className="w-10 h-10 text-primary" />
        </div>
        <h1 className="text-3xl font-display font-bold">
          Welcome to Pro
        </h1>
        <p className="text-muted-foreground">
          Your full Business Intelligence is now unlocked. Survival breakdown, Dead Stock values, and AI insights are ready.
        </p>
        <Button data-testid="post-upgrade-cta" size="lg" onClick={dismiss} className="font-semibold">
          Explore my dashboard
        </Button>
      </div>
    </div>
  );
}
